import React from "react";
import "./PaymentType.scss";
import { MdKeyboardBackspace } from "react-icons/md";
import { baseUrl } from "../../utils/config/urls";
import { getAccessToken } from "../../utils/services/auth";
import axios from "axios";
import { useSelector } from "react-redux";
import { changeStore } from "../../store/useStore";
import { DisclaimerBar } from "../../components";

interface PaymentTypeProps {
  setCurrentScreen: (screen: string | null) => void;
  selectedPlan: { index: string } | null;
}

const PaymentType: React.FC<PaymentTypeProps> = ({
  setCurrentScreen,
  selectedPlan,
}) => {
  const userStore = useSelector((store: any) => store?.balance);
  const currentChainStore = useSelector((store: any) => store?.currentChain);
  const authStore = useSelector((store: any) => store?.auth);
  const otherStore = useSelector((store: any) => store?.otherData);

  const proceedPayment = (type: string) => {
    if (!userStore?.email) {
      changeStore("setData", { isVerifyEmailDialog: true });
      return;
    }
    if (type === "crypto") {
      setCurrentScreen("PaymentCrypto");
    }
    if (type === "fiat") {
      setCurrentScreen("Loading");
      payUsingFiat();
    }
  };

  const payUsingFiat = async () => {
    const url = `${baseUrl}/api/topup/purchase_plan_via_stripe?subscriptionId=${selectedPlan?.index}`;
    const response = await axios.get(url, {
      headers: {
        Authorization: `Bearer ${getAccessToken()}`,
      },
    });
    if (response.status === 200) {
      window.open(response.data.url, "_self");
    }
  };

  const payUsingCrypto = async ()=>{
    if(authStore?.blockchain === 'EVM'){
      (currentChainStore?.currentChain === 'polygon' || currentChainStore?.currentChain === 'fvm' || currentChainStore?.currentChain === 'base') && (proceedPayment("crypto"))
    }else{
      proceedPayment("crypto");
    }
  }

  return (
    <div className="PaymentType">
      {/* {(currentChainStore?.currentChain !== "polygon" && authStore?.blockchain == 'EVM') && (
        <DisclaimerBar
          title={"Crypto Payment On Polygon Only"}
          content={
            "Please change your chain to polygon mainnet to top-up your existing storage using crypto"
          }
          isConnectToPolygon = {true}
        />
      )} */}
      <p className="PaymentType__title">
        <span onClick={() => setCurrentScreen(null)}>
          <MdKeyboardBackspace />
        </span>
        &nbsp; Payment Type
      </p>

      <div className="PaymentType__contentBox">
        <p>Select your favourable payment method to complete the payment.</p>
        <div className="cardContainer">
          <button className="TypeCard" disabled={authStore?.blockchain == 'EVM' ? currentChainStore?.currentChain === "optimism" : false} onClick={payUsingCrypto}>
            <div className="TypeCard__icon">
              <img src={"/icons/Crypto_Icon.svg"} alt="pricecardIcon" style={{ filter: otherStore.theme === 'dark' ? 'invert(1)' : 'none' }} />
            </div>
            <p className="TypeCard__title">Pay Using Crypto</p>
          </button>
          <button className="TypeCard" onClick={() => proceedPayment("fiat")}>
            <div className="TypeCard__icon">
              <img src={"/icons/Fiat_Icon.svg"} alt="pricecardIcon" style={{ filter: otherStore.theme === 'dark' ? 'invert(1)' : 'none' }} />
            </div>
            <p className="TypeCard__title">Pay Using Fiat</p>
          </button>
        </div>
      </div>
    </div>
  );
};

export default PaymentType;
